import { IGeoSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCity } from './getCity';
import { getTrapGeoTagsText } from './GetTrapGeoTagsText';
import { isSubwayAdded } from './isSubwayAdded';

/**
 * Формирует текст для районов: выбранного города и гео тегов.
 */
export function getTrapRegionsText(geo: IGeoSchema): string {
  const { undergrounds, address } = geo;
  let text = '';

  if (isSubwayAdded(undergrounds)) {
    text = text.concat(' или');
  }

  // пробел между getCity и getTrapGeoTagsText не нужен
  text = text.concat(` в указанном районе (${getCity(address)}${getTrapGeoTagsText(address)})`);

  return text;
}
